import type { CSSProperties } from 'react';
import UnarchiveIconSvg from '../../assets/icons/unarchive.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const UnarchiveIcon: React.FC<IconProps> = ({ size = 16, className = '', style = {}, onClick }) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <UnarchiveIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default UnarchiveIcon;
